import {FloatingLabel, Form} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {appSelector, setJbpDetail} from '../../../../../redux/slices/appSlices'

export const InputDescription = () => {
  const {t} = useTranslation()
  const {jbpDetail: jbp} = useAppSelector(appSelector)
  const dispatch = useAppDispatch()

  const handleChange = (value: string) => {
    dispatch(setJbpDetail({...jbp, description: value}))
  }

  return (
    <Form.Group className='w-100 mb-5' controlId='input-description'>
      <Form.Label>{t('deskrisi')}</Form.Label>
      <FloatingLabel controlId='floatingTextarea' label={t('deskrisi')} className='mb-3'>
        <Form.Control
          as='textarea'
          placeholder='Leave a comment here'
          defaultValue={jbp?.description ?? ''}
          onChange={(e: any) => handleChange(e.target.value)}
        />
      </FloatingLabel>
    </Form.Group>
  )
}
